module.exports = __webpack_public_path__ + "static/media/report_work_on.d3ec8e09.svg";